import { Pipe, PipeTransform, inject } from '@angular/core';

import { RouteTranslatorService } from './route-translator.service';

/**
 * Translates a routerLink/href value through the `ROUTES.*` keys of the active locale.
 *
 *   [routerLink]="['/Misc_tutor_search'] | localize"     -> ['/docenten']
 *   [routerLink]="[profileLinkBase, connection.id] | localize"
 *   [href]="'OnlineDemoSection' | localize"
 *
 * Unlike the original this pipe is pure. The original had to be impure because it
 * translated against an asynchronously-resolved translation object and forced a
 * `detectChanges()` on a timeout. Here translations are loaded in `APP_INITIALIZER`
 * before the app bootstraps, and the active locale is fixed per domain (no runtime
 * language switching), so the result is stable for the lifetime of the page.
 */
@Pipe({
  name: 'localize',
  standalone: true,
  pure: true
})
export class LocalizePipe implements PipeTransform {
  private readonly translator = inject(RouteTranslatorService);

  transform(query: string): string;
  transform(query: unknown[]): unknown[];
  transform(query: string | unknown[]): string | unknown[];
  transform(query: string | unknown[]): string | unknown[] {
    if (!query || query.length === 0) {
      return query;
    }
    return this.translator.translateRoute(query);
  }
}
